import React, { useState, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import { debounce } from "lodash";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import useDebounce from "../../../components/utilities/useDebounce";
import InputFloatingStyle from "../../../../sass/floatingLabel.scss";

import Icon from "@mdi/react";
import {
    mdiContentSaveCheck,
    mdiContentSaveCog,
    mdiContentSaveOutline,
    mdiContentSaveSettings,
} from "@mdi/js";
import FloatingInputSuiviDossier from "./FloatingInputSuiviDossier";
import Styles from "./FormDetail.scss";

const CompteUserForm = ({ props, user, updateUserInfo }) => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {},
    });
    const {
        register: registerPassword,
        handleSubmit: handleSubmitPassword,
        formState: { errors: errorPassword },
    } = useForm({
        mode: "onSubmit",
        defaultValues: {},
    });

    const submitAfterDebounce = (e) => {
        let submitBtn = document.querySelector("#ue_user_form_hidden_submit");
        submitBtn.click();
    };

    const handleUpdatePassword = async (data) => {
        const args = {
            password: data.password,
            verify_password: data.verify_password,
        };
        try {
            const result = await axios.post("/Api/user/password", args);
            result.data
                ? toast.success(
                      "Actualisation de vos données utilisateur réussie",
                      { id: "user" }
                  )
                : null;
        } catch (err) {
            console.log(err);
            toast.error(
                "Un problème est survenu lors de l`'actualisation de vos données"
            );
        }
    };

    const handleUpdateUser = async (data) => {
        const args = { data };
        try {
            const result = await axios.put("/Api/user", args);
            updateUserInfo(data);
            result.data
                ? toast.success(
                      "Actualisation de vos données utilisateur réussie",
                      { id: "user" }
                  )
                : null;
        } catch (err) {
            toast.error(
                "Un problème est survenu lors de l`'actualisation de vos données"
            );
        }
    };

    return (
        <div className={"form w-100"}>
            {/*<DevTool control={control} />  set up the dev tool */}
            <form id="ue-user-form" onSubmit={handleSubmit(handleUpdateUser)}>
                <div className="form-row">
                    <div className="col-12 col-md-6 m-0">
                        {/* <label
                            htmlFor="name"
                            className={"col-form-label ue-col-form-label"}
                            style={{ paddingRight: "0" }}
                        >
                            Nom :
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            {...register("name")}
                            onChange={debounce(submitAfterDebounce, 2000)}
                            defaultValue={user?.name ? user.name : ""}
                            style={{
                                padding: "5px",
                                border: "none",
                                backgroundColor: "#F9F9F9",
                                fontSize: "11px",
                            }}
                        /> */}
                        <div className="did-floating-label-content">
                            <input
                                className="did-floating-input"
                                type="text"
                                id={"name"}
                                name={"name"}
                                placeholder=" "
                                {...register("name")}
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={user?.name ? user.name : ""}
                            ></input>
                            <label className="did-floating-label">Nom</label>
                        </div>

                        {errors.user_name && (
                            <span className={"text-danger mt-1"}>Nom</span>
                        )}
                    </div>
                    <div className="col-12 col-md-6 m-0">
                        {/* <label
                            htmlFor="forename"
                            className={"col-form-label ue-col-form-label"}
                            style={{ padding: "0" }}
                        >
                            Prénom :
                        </label>
                        <input
                            type="text"
                            id="forename"
                            name="forename"
                            {...register("forename")}
                            onChange={debounce(submitAfterDebounce, 2000)}
                            defaultValue={user?.forename ? user.forename : ""}
                            style={{
                                padding: "4px",
                                marginTop: "4px",
                                border: "none",
                                backgroundColor: "#F9F9F9",
                                fontSize: "11px",
                            }}
                        /> */}
                        <div className="did-floating-label-content">
                            <input
                                className="did-floating-input"
                                type="text"
                                id={"forename"}
                                name={"forename"}
                                placeholder=" "
                                {...register("forename")}
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={
                                    user?.forename ? user.forename : ""
                                }
                            ></input>
                            <label className="did-floating-label">Prénom</label>
                        </div>

                        {errors.user_forename && (
                            <span className={"text-danger mt-1"}>
                                Ce champ est requis !
                            </span>
                        )}
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 m-0">
                        {/* <div style={{}}>
                            <label
                                htmlFor="username"
                                className={"col-form-label ue-col-form-label"}
                            >
                                Rôle de l'utilisateur :
                            </label>
                            <input
                                type="text"
                                id="user_role"
                                name="user_role"
                                readOnly
                                value={
                                    user?.isLeader
                                        ? "Gestionnaire"
                                        : "Simple utilisateur"
                                }
                                style={{
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "#F9F9F9",
                                }}
                            />
                        </div> */}
                        <div className="did-floating-label-content">
                            <input
                                className="did-floating-input"
                                type="text"
                                id={"user_role"}
                                name={"user_role"}
                                placeholder=" "
                                readOnly
                                value={
                                    user?.isLeader
                                        ? "Gestionnaire"
                                        : "Simple utilisateur"
                                }
                            ></input>
                            <label className="did-floating-label">
                                Rôle de l'utilisateur
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 m-0">
                        {/* <label
                            htmlFor="username"
                            className={"col-form-label ue-col-form-label"}
                        >
                            Identifiant :
                        </label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            onChange={debounce(submitAfterDebounce, 2000)}
                            readOnly
                            {...register("username")}
                            defaultValue={user?.username ? user.username : ""}
                            style={{
                                padding: "8px",
                                border: "none",
                                backgroundColor: "#F9F9F9",
                            }}
                        /> */}
                        <div className="did-floating-label-content">
                            <input
                                className="did-floating-input"
                                type="text"
                                id={"username"}
                                name={"username"}
                                placeholder=" "
                                onChange={debounce(submitAfterDebounce, 2000)}
                                readOnly
                                {...register("username")}
                                defaultValue={
                                    user?.username ? user.username : ""
                                }
                            ></input>
                            <label className="did-floating-label">
                                Identifiant
                            </label>
                        </div>
                        {errors.user_username && (
                            <span className={"text-danger mt-1"}>
                                Ce champ est requis !
                            </span>
                        )}
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 m-0">
                        {/* <label
                            htmlFor="email"
                            className={"col-form-label ue-col-form-label"}
                        >
                            Email :
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            readOnly
                            onChange={debounce(submitAfterDebounce, 2000)}
                            {...register("email")}
                            defaultValue={user?.email ? user.email : ""}
                            style={{
                                padding: "8px",
                                border: "none",
                                backgroundColor: "#F9F9F9",
                            }}
                        /> */}
                        <div className="did-floating-label-content">
                            <input
                                className="did-floating-input"
                                type="text"
                                id={"email"}
                                name={"email"}
                                placeholder=" "
                                readOnly
                                onChange={debounce(submitAfterDebounce, 2000)}
                                {...register("email")}
                                defaultValue={user?.email ? user.email : ""}
                            ></input>
                            <label className="did-floating-label">Email</label>
                        </div>
                        {errors.user_email && (
                            <span className={"text-danger mt-1"}>
                                Ce champ est requis !
                            </span>
                        )}
                    </div>
                </div>
                <button
                    type={"submit"}
                    id={"ue_user_form_hidden_submit"}
                    style={{ display: "none" }}
                />
            </form>
            <form
                id={"form-user-psw"}
                onSubmit={handleSubmitPassword(handleUpdatePassword)}
            >
                <div className="form-row">
                    <div className="col-12 col-md-5">
                        {/* <label
                            htmlFor="password"
                            className={"col-form-label ue-col-form-label "}
                        >
                            Mot de passe :
                        </label>
                        <input
                            placeholder="Mot de passe :"
                            type="password"
                            required={true}
                            id="password"
                            name="password"
                            autoComplete="off"
                            {...registerPassword("password")}
                            style={{
                                padding: "8px 38px 8px 10px",
                                border: "none",
                                backgroundColor: "#F9F9F9",
                                fontSize: "10px",
                            }}
                        /> */}
                        <div className="did-floating-label-content">
                            <input
                                className="did-floating-input"
                                type="password"
                                id={"password"}
                                name={"password"}
                                required={true}
                                placeholder=" "
                                autoComplete="off"
                                {...registerPassword("password")}
                            ></input>
                            <label className="did-floating-label">
                                Mot de passe
                            </label>
                        </div>
                        {errorPassword.password && (
                            <span className={"text-danger mt-1"}>
                                Ce champ est requis !
                            </span>
                        )}
                    </div>

                    <div className="col-12 col-md-4">
                        {/* <label
                            htmlFor="password_confirmation"
                            className={"col-form-label ue-col-form-label"}
                        >
                            Vérification :
                        </label>
                        <input
                            placeholder="Vérification :"
                            type="password"
                            id="password_confirmation"
                            name="password_confirmation"
                            required={true}
                            {...registerPassword("password_confirmation")}
                            style={{
                                padding: "8px",
                                border: "none",
                                backgroundColor: "#F9F9F9",
                                fontSize: "10px",
                            }}
                        /> */}
                        <div className="did-floating-label-content">
                            <input
                                className="did-floating-input"
                                type="password"
                                id={"password_confirmation"}
                                name={"password_confirmation"}
                                placeholder=" "
                                required={true}
                                {...registerPassword("password_confirmation")}
                            ></input>
                            <label className="did-floating-label">
                                {" "}
                                Vérification
                            </label>
                        </div>

                        {errorPassword.password_confirmation && (
                            <span className={"text-danger mt-1"}>
                                Ce champ est requis !
                            </span>
                        )}
                    </div>
                    <div
                        className="col-12 col-md-3"
                        style={{ paddingTop: "10px" }}
                    >
                        <button
                            type="submit"
                            className="btn btn-block btn-primary text-white"
                            style={{
                                fontWeight: "700",
                                fontSize: "0.6rem",
                                width: "50%",
                                margin: "auto",
                            }}
                        >
                            VALIDER
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userId: state.MeReducer.id,
        username: state.MeReducer.username,
        isLeader: state.MeReducer.isLeader,
        role: state.MeReducer.role,
        types: state.SubscribtionReducer.types,
        structureInfo: state.SubscribtionReducer.structureInfo,
        entity: state.MeReducer.entity,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        updateStructureInfo: (e) =>
            dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
        updateUserInfo: (e) =>
            dispatch({ type: "UPDATE_USER_STATUS", data: e }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(CompteUserForm);
